var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.success)?_c('h1',{staticClass:"sli lundi b-b"},[_vm._v(_vm._s(_vm.success[0].title))]):_vm._e(),_c('div',{staticClass:"sli",domProps:{"innerHTML":_vm._s(_vm.success[0].text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }